import styled from "styled-components";

export const ResponsiveTable = styled.table`
    width: 100%;
    @media (max-width: ${props => props.theme.maxWidth}) {
        table,
        thead,
        tbody,
        th,
        td,
        tr {
            display: block;
        }

        [data-label] {
            text-align: right;
        }

        tr {
            border: none;
        }

        thead tr {
            position: absolute;
            top: -9999px;
            left: -9999px;
        }

        tr:not(:last-of-type) {
            margin-bottom: 10px;
        }

        td {
            border: none;
            border-bottom: 1px solid #eee;
            position: relative;
            height: 3.2em !important;
            line-height: 2em;
        }

        tr td:last-child {
            border-bottom: none !important;
        }

        tr:nth-of-type(n + 2) td:nth-of-type(1) {
            padding-top: 8px !important;
        }

        td:before {
            position: absolute;
            top: 6px;
            left: 6px;
            padding-right: 10px;
            white-space: nowrap;
            content: attr(data-label);
        }
    }
`;
